import React from "react";
import { FaTimes, FaRegUser } from "react-icons/fa";
import { FiSearch, FiShoppingCart, FiHeart } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";
import "./Drawer.css";
import { colors } from "../../../../constants/colors";

const Drawer = ({
  isOpen,
  onClose,
  categories,
  userData,
  isCategoriesDropdownOpen,
  isAccountDropdownOpen,
  toggleCategoriesDropdown,
  toggleAccountDropdown,
  handleNavigation,
  onLogout,
  openCartDrawer,
  newMessageFlag
}) => {
  if (!isOpen) return null;

  return (
    <div className="drawerOverlay" onClick={onClose}>
      <div className="drawer" onClick={(e) => e.stopPropagation()}>
        <div className="drawerHeader">
          <h3>MENU</h3>
          <button className="drawerClose" onClick={onClose}>
            <FaTimes size={20} color={colors.primary} />
          </button>
        </div>

        <div className="drawerContent">
          <button className="drawerItem" onClick={() => handleNavigation("/")}>
            Home
          </button>
          <div className="drawerDivider" />
          <div className="drawerDropdown">
            <div className="drawerItem drawerItem--dropdown">
              <button
                className="drawerItemText"
                onClick={() => handleNavigation("/search")}
              >
                All
              </button>
              <button
                className="drawerItemArrow"
                onClick={toggleCategoriesDropdown}
              >
                <IoIosArrowDown
                  size={16}
                  color={colors.primary}
                  style={{
                    transform: isCategoriesDropdownOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </button>
            </div>
            {isCategoriesDropdownOpen && (
              <div className="drawerSubmenu">
                {categories?.map((cat) => (
                  <button
                    key={cat?._id}
                    className="drawerSubItem"
                    onClick={() =>
                      handleNavigation(`/category?category_id=${cat?._id}`, {
                        state: { category: cat },
                      })
                    }
                  >
                    {cat?.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          {categories?.slice(0, 2)?.map((cat) => (
            <>
              <div className="drawerDivider" />
              <button
                key={cat?._id}
                className="drawerItem"
                onClick={() =>
                  handleNavigation(`/category?category_id=${cat?._id}`, {
                    state: { category: cat },
                  })
                }
              >
                {cat?.name}
              </button>
            </>
          ))}

          <div className="drawerDivider" />

          <button
            className="drawerItem"
            onClick={() => handleNavigation("/search")}
          >
            <FiSearch size={16} color={colors.primary} />
            Search
          </button>
          <div className="drawerDivider" />

          <button
            className="drawerItem"
            onClick={() => {
              onClose();
              openCartDrawer();
            }}
          >
            <FiShoppingCart size={16} color={colors.primary} />
            Cart
          </button>
          <div className="drawerDivider" />

          <button
            className="drawerItem"
            onClick={() => handleNavigation("/whishlist")}
          >
            <FiHeart size={16} color={colors.primary} />
            Wishlist
          </button>
          <div className="drawerDivider" />
          <div className="drawerDropdown">
            <button
              className="drawerItem drawerItem--dropdown"
              onClick={toggleAccountDropdown}
            >
              <FaRegUser size={16} color={colors.primary} />
              <span>My account</span>
              <IoIosArrowDown
                size={16}
                color={colors.primary}
                style={{
                  transform: isAccountDropdownOpen
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </button>
            {isAccountDropdownOpen && (
              <div className="drawerSubmenu">
                {userData && (
                  <>
                    <button
                      className="drawerSubItem"
                      onClick={() => handleNavigation("/profile")}
                    >
                      Profile
                    </button>
                    <button
                      className="drawerSubItem"
                      onClick={() => handleNavigation("/change-password")}
                    >
                      Change Password
                    </button>
                  </>
                )}

                <button
                  className="drawerSubItem"
                  onClick={() => handleNavigation("/orders")}
                >
                  My Order
                </button>
                {userData && (
                  <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between', gap: '8px' }}>
                    <button
                      className="drawerSubItem"
                      onClick={() => handleNavigation("/support-tickets")}
                      style={{ flex: '1', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                      My Tickets
                    </button>
                    {Number(newMessageFlag) === 1 && (
                      <span className="drawerNewReply">New Reply</span>
                    )}
                  </div>
                )}

                <button
                  className="drawerSubItem"
                  onClick={() => handleNavigation("/notifications")}
                >
                  Notifications
                </button>
                {userData && userData?.user_type === "wholeseller" && (
                  <button
                    className="drawerSubItem"
                    onClick={() => handleNavigation("/bank-details")}
                  >
                    Bank Details
                  </button>
                )}
                <button
                  className="drawerSubItem"
                  onClick={() => {
                    window.open("/contact-us", "_blank");
                  }}
                >
                  Contact Us
                </button>
                {userData ? (
                  <button
                    className="drawerSubItem drawerLogout"
                    onClick={onLogout}
                  >
                    Logout
                  </button>
                ) : (
                  <button
                    className="drawerSubItem"
                    onClick={() => handleNavigation("/login")}
                  >
                    Login
                  </button>
                )}
              </div>
            )}
          </div>
          <div className="drawerDivider" />
        </div>
      </div>
    </div>
  );
};

export default Drawer;
